// TablaDatos — tabla simple reutilizable.
// columnas: [{ titulo, render: (fila) => nodo, align? }]
// cabecera (opcional): { bgcolor, color } para colorear la fila de títulos.

import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

export default function TablaDatos({ columnas, filas, vacio = 'No hay registros.', claveFila = (f) => f.id, cabecera }) {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            {columnas.map((c) => (
              <TableCell key={c.titulo} align={c.align} sx={cabecera ? { bgcolor: cabecera.bgcolor, color: cabecera.color, fontWeight: 700 } : undefined}>
                {c.titulo}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filas.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columnas.length} align="center" sx={{ py: 4 }}>
                <Typography color="text.secondary">{vacio}</Typography>
              </TableCell>
            </TableRow>
          ) : (
            filas.map((f, i) => (
              <TableRow key={claveFila(f) ?? i} hover>
                {columnas.map((c) => (
                  <TableCell key={c.titulo} align={c.align}>
                    {c.render(f)}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
